module.exports = __webpack_public_path__ + "img/logo.0c5e37ec.png";